import Navbar from "../../../components/Navbar/Navbar";
import StatementOfAccount from "../components/StatementOfAccount/StatementOfAccount";

export default function StatementOfAccountPage() {
    return (
        <>
            <Navbar title="Statement of Account" />

            <StatementOfAccount />
        </>
    );
}
